import { render, staticRenderFns } from "./RelatorioFaturamentoListRoute.vue?vue&type=template&id=ad7ad444"
import script from "./RelatorioFaturamentoListRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioFaturamentoListRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports